module.exports = __webpack_public_path__ + "img/117.4f728399.jpg";